import React from 'react';
import {ApolloProvider} from "@apollo/client";
import {BrowserRouter} from 'react-router-dom';
import plPL from 'antd/es/locale/pl_PL';
import {ConfigProvider} from "antd";
import MainView from "./views/MainView";
import Suspense from "./components/Suspense";
import keycloak from "./keycloak";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import createClient from "./backend/apolloClient";

function App() {
    const tokensHandler = (tokens: any) => {
        window.localStorage.setItem('keycloakToken', tokens.token)
    }

    // apollo client
    const apolloClient = createClient()

    return (
        <ReactKeycloakProvider authClient={keycloak}
                               initOptions={{onLoad: 'login-required'}}
                               onTokens={tokensHandler}
                               LoadingComponent={<Suspense/>}>
                <React.Suspense fallback={<Suspense/>}>
                    <ApolloProvider client={apolloClient}>
                        <BrowserRouter>
                            <ConfigProvider locale={plPL}>
                                <MainView/>
                            </ConfigProvider>
                        </BrowserRouter>
                    </ApolloProvider>
                </React.Suspense>
        </ReactKeycloakProvider>
    );
}

export default App;
